import { OnInit, Output, Input, Component, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { TypeaheadMatch } from 'ngx-bootstrap';import { ProgramService } from '../../../client-core/services/program.service';
import { TypeaheadConfig } from '../typeahead-config.model';
import { AppDatatableConfigOptions } from '../../datatable/models/config-options.model';
import { PaginationInfo } from '../../../client-core/api-response-models/pagination-info.model';
import { ApiResponse, ApiPagedResponse } from '../../../client-core/api-response-models';
import { StateLookupDto } from '../../../client-core/dtos/programs.model';

@Component({
    selector: 'states-select',
    templateUrl: 'states-select.component.html'
})
export class StatesSelectComponent implements OnInit {

    @Input()
    showBlank: boolean;

    @Output()
    onSelected = new EventEmitter<string>();

    @Input() selectedValue: string;

    @Input() disabled: boolean;

    private _item: string;
    
    set item(val: string) {
        this._item = val;
        this.onSelected.emit(val);
    }

    get item(): string {
        return this._item;
    }

    states: StateLookupDto[];

    constructor(
        private service: ProgramService) {

    }

    ngOnInit() {
        this.service.getStatesLookup()
            .subscribe(res => {
                if (!res.hasError) {
                    if (res.data) {
                        this.states = res.data.items;
                    }
                    else {
                        //this.validationMessages = new ValidationMessage(null, true, "Account lookup could not be loaded");
                    }
                } else {
                    //this.validationMessages = new ValidationMessage(res._error, true, "Account lookup could not be loaded");
                }
            },
            (err: any) => {
                //this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured when loading Account lookup");
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/selects/states/states-select.component.ts